/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Tap_To_RetryInputs */

const en_common_tap_to_retry = /** @type {(inputs: Common_Tap_To_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to retry.`)
};

const es_common_tap_to_retry = /** @type {(inputs: Common_Tap_To_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para intentar de nuevo.`)
};

/**
* | output |
* | --- |
* | "Tap to retry." |
*
* @param {Common_Tap_To_RetryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_tap_to_retry = /** @type {((inputs?: Common_Tap_To_RetryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Tap_To_RetryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_tap_to_retry(inputs)
	return en_common_tap_to_retry(inputs)
});